module.exports = __webpack_public_path__ + "img/VolumeMuteOutlined.6fed2357.svg";